export const displayPercentileStatus = (percentile: number) => {
  if (percentile < 50) return 'Bottom 50%';
  if (percentile < 60) return 'Top 50%';
  if (percentile < 70) return 'Top 40%';
  if (percentile < 80) return 'Top 30%';
  if (percentile < 90) return 'Top 20%';
  if (percentile < 99) return 'Top ' + (100 - percentile + '%');
  if (percentile >= 99) return 'Top 1%';
};
